/**
 * Foundation / concealer shades aligned to the 10-band skin tone scale
 * (Very Fair → Very Deep). Hexes must stay in sync with
 * backend/shared/color_utils.py FOUNDATION_HEX_LIST.
 */
export const skinToneColors = [
  { name: 'Very Fair', hex: '#FAF5F0' },
  { name: 'Fair', hex: '#F4DFC4' },
  { name: 'Light', hex: '#F0D2A0' },
  { name: 'Light-Medium', hex: '#E6BE94' },
  { name: 'Medium', hex: '#CFAA84' },
  { name: 'Medium-Tan', hex: '#B98A67' },
  { name: 'Tan', hex: '#A9714B' },
  { name: 'Medium-Deep', hex: '#855E45' },
  { name: 'Deep', hex: '#5C3828' },
  { name: 'Very Deep', hex: '#3F291A' },
];

/** All bands available for “recommended” highlight chips. */
export const skinToneRecommendedHexes = skinToneColors.map((c) => c.hex);
